import PanelRight from "src/Component/PanelRight";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import store from "src/Reducers/store";
import Screen12 from "./Screen12";
import FrameTV from "src/Component/FrameTV";
import PanelButtonsColors from "src/Component/PanelButtonsColors";

const PageId = 12;
const BackPageId = PageId - 1;
const NextPageId = PageId + 1;

const DATA = () => {
  const baseImageBG = `${Config.BASE_URL}/images/BG/`;
  const baseImages = `${Config.BASE_URL}/images/screen_${PageId}/`;
  const baseImagesScreen8 = `${Config.BASE_URL}/images/screen_8/`;

  const currentPage = useSelector(() => store.getState().appReducer.currentPage);

  const [step, setStep] = useState<number>(0);

  useEffect(() => {
    setStep(PageId === currentPage ? 1 : 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  const title = "Your Brand, Your Way";

  const description =
    "Empower your business with complete\ncustomization. The Infosys Entertainment Platform\noffers full white-label capabilities, allowing you to\nalign the platform with your brand identity and\nmarket needs.\n\n<b>Key Features:</b>\n\n<b>Customizable UI Elements:</b> Modify colors,\nfonts, and layouts to match your branding.\n\n<b>Flexible Themes:</b> Choose from pre-set color\nschemes or create your own.\n\n<b>Brand Integration:</b> Incorporate your logos and\nvisuals to make the platform truly yours.";

  const bundles = [
    { id: 1, image: `${baseImagesScreen8}promotional-tile-0.jpg`, categories: "" },
    { id: 2, image: `${baseImagesScreen8}promotional-tile-1.jpg`, categories: "", activeBorder: true },
    { id: 3, image: `${baseImagesScreen8}promotional-tile-2.jpg`, categories: "" },
    { id: 4, image: `${baseImagesScreen8}promotional-tile-3.jpg`, categories: "" },
    { id: 4, image: `${baseImagesScreen8}promotional-tile-4.jpg`, categories: "" },
  ];

  const bundlesPkg = [
    { id: 1, image: `${baseImagesScreen8}small-promotional-tile-0.jpg`, categories: "" },
    { id: 2, image: `${baseImagesScreen8}small-promotional-tile-1.jpg`, categories: "" },
    { id: 3, image: `${baseImagesScreen8}small-promotional-tile-2.jpg`, categories: "" },
    { id: 4, image: `${baseImagesScreen8}small-promotional-tile-3.jpg`, categories: "" },
    { id: 5, image: `${baseImagesScreen8}small-promotional-tile-4.jpg`, categories: "" },
  ];

  const DATA_IMAGES = [
    { image: `${baseImages}TV Shop-0.jpg`, hex: "#017ABF", border: "#007CC3" },
    { image: `${baseImages}TV Shop-1.jpg`, hex: "#25D74D", border: "#D0FFBE" },
    { image: `${baseImages}TV Shop-2.jpg`, hex: "#543286", border: "#D4B0F7" },
    { image: `${baseImages}TV Shop-3.jpg`, hex: "#890714", border: "#FF9791" },
    { image: `${baseImages}TV Shop-4.jpg`, hex: "#080D13", border: "#ABE0FF" },
  ];

  const [selectedImage, setSelectedImage] = useState(DATA_IMAGES[0]);
  const handleButtonClick = (color: any) => setSelectedImage(color);

  return {
    bgImage: `${baseImageBG}BG_2.jpg`,
    title,
    description,
    rightSideComponent: (
      <>
        <PanelRight>
          <FrameTV scrollTop={step >= 3}>
            <Screen12
              selectedImage={selectedImage}
              step={step}
              setStep={setStep}
              pageId={PageId}
              bundles={bundles}
              bundlesPkg={bundlesPkg}
            />
          </FrameTV>
        </PanelRight>
        <PanelButtonsColors colors={DATA_IMAGES} handleOnClick={handleButtonClick} />
      </>
    ),
    back: {
      label: "Back",
      type: "back",
      startIcon: { icon: "arrow-right", color: "#fff" },
      onClick: () => setCurrentPage(BackPageId),
      style: { gap: "var(--width-16)" },
    },
    next: {
      label: "Continue",
      type: "next",
      endIcon: { icon: "arrow-left" },
      onClick: () => setCurrentPage(NextPageId),
      style: { gap: "var(--width-16)" },
    },
  };
};

export default DATA;
